import { AuthPageContentWrapper } from 'components/AuthPageContentWrapper';
import { OffsetElementType } from 'components/AuthPageContentWrapper/AuthPageContextWrapper.types';
import { TabNavigation } from 'components/TabNavigation';
import { usePathname } from 'hooks/usePathname';
import CustomFieldsSettingsPage from 'pages/SettingsPage/CustomFieldsSettingsPage/CustomFieldsSettingsPage';
import { SeniorityRankingPage } from 'pages/SettingsPage/OrganizationSettingsPage/SeniorityRankingPage';
import { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import {
  isCustomFieldsFeatureEnabledSelector,
  isOrganizationMultiLocationTieringEnabledSelector,
} from 'store/selectors/featureFlagSelectors';

const offsetElements: OffsetElementType[] = ['DesktopPageHeaderHeight', 'TabNavigationHeight'];

export const OrganizationSettingsPage = () => {
  const activeTab = usePathname();
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  const isOrganizationMultiLocationTieringEnabled = useSelector(
    isOrganizationMultiLocationTieringEnabledSelector,
  );
  const isCustomFieldsFeatureEnabled = useSelector(isCustomFieldsFeatureEnabledSelector);

  const tabs = useMemo(() => {
    const settingsOptions = [];

    if (isOrganizationMultiLocationTieringEnabled) {
      settingsOptions.push({
        label: t('settings:SENIORITY_RANKING'),
        path: '/settings/organization/seniority-ranking',
        activePaths: ['/settings/organization/seniority-ranking'],
      });

      if (isCustomFieldsFeatureEnabled) {
        settingsOptions.push({
          label: t('common:CUSTOM_FIELDS'),
          path: '/settings/organization/custom-fields',
          activePaths: ['/settings/organization/custom-fields'],
        });
      }
    }
    return settingsOptions;
  }, [isCustomFieldsFeatureEnabled, isOrganizationMultiLocationTieringEnabled, t]);

  const isSeniorityRankingTabSelected = activeTab.startsWith(
    '/settings/organization/seniority-ranking',
  );

  const isCustomFieldsTabSelected = activeTab.startsWith('/settings/organization/custom-fields');

  return (
    <Fragment>
      <TabNavigation activeTab={activeTab} tabs={tabs} />
      <AuthPageContentWrapper offsetElements={offsetElements}>
        {isOrganizationMultiLocationTieringEnabled && isSeniorityRankingTabSelected && (
          <Switch>
            <Route path={`${path}/seniority-ranking`} component={SeniorityRankingPage} />
          </Switch>
        )}
        {isCustomFieldsFeatureEnabled && isCustomFieldsTabSelected && (
          <Switch>
            <Route path={`${path}/custom-fields`} component={CustomFieldsSettingsPage} />
          </Switch>
        )}
      </AuthPageContentWrapper>
    </Fragment>
  );
};
